// WHAT: Oura Error Display Component
// WHY:  Simple error message display for Oura-related errors
// DOMAIN: Health → Oura
// DEPENDENCIES: React
// RISKS:
//   - NOTE: Error message is displayed as-is (no sanitization)
//   - NOTE: Uses hardcoded German text ("Fehler")

import { type FC } from "react";

interface OuraErrorProperties {
  message: string;
}

/**
 * WHAT:
 *   Simple error message component for Oura data errors.
 *
 * WHY:
 *   Provides consistent error display across Oura components.
 *
 * PROPS:
 *   - message: string — Error message to display
 *
 * BEHAVIOR:
 *   - Displays error icon (⚠️) and message in error color
 *   - Uses flexbox for icon and text alignment
 *   - Text is bold (font-semibold) and uses error color class
 *
 * RISKS:
 *   - NOTE: Message is displayed without sanitization (XSS risk if user-controlled)
 *   - NOTE: Hardcoded German text ("Fehler") - not internationalized
 *
 * @param root0
 *
 * @param root0.message
 *
 * @returns JSX element displaying error message.
 *
 */
export const OuraError: FC<OuraErrorProperties> = ({ message }) => (
  <div className="text-error font-semibold flex items-center gap-2">⚠️ Fehler: {message}</div>
);
